module.exports = __webpack_public_path__ + "img/bg-ep-STR.aab1ac24.jpg";